import Theme from 'Theme';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import Notice from 'components/Notice';
import Icons from 'components/Icons';

import { errorClear } from 'actions/error';

export class ErrorMessage extends Component {
  componentDidMount() {
    let { errorClear } = this.props;

    errorClear && errorClear();
  }

  render() {
    let {
      error: { message, type }
    } = this.props;

    if (!message || (this.props.for && this.props.for !== type)) return null;

    return (
      <div>
        <Notice
          color={type === 'warning' ? Theme.warningColor : Theme.dangerColor}
          fontWeight={400}
          text={message.error || message}
          secondaryColor={
            type === 'warning' ? Theme.warningColorLight : Theme.dangerColorLight
          }
          renderIcon={() => {
            return type === 'warning' ? (
              <Icons.InputError key={1} color={Theme.warningColor} /> // conditional mounting + keys due to react-meaterial-icons lib being terrible
            ) : (
              <Icons.InputError key={2} color={Theme.dangerColor} />
            );
          }}
        />
      </div>
    );
  }
}

let mapDispatchToProps = {
  errorClear
};

let mapStateToProps = ({ error, orders, session }) => ({
  error,
  orders,
  session
});

export const ConnectedErrorMessage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorMessage);